// generated by scripts/emit_composition_settings.py, do not edit
// Source of truth: apps/backend/services/composition/settings_spec.py
// Regenerate with `make generate-types`; CI fails on drift.

export const COMPOSITION_SETTINGS = {
  "column_format": {
    "decimals": [
      0,
      3
    ],
    "negatives": [
      "minus",
      "parentheses"
    ],
    "units": [
      "none",
      "K",
      "M"
    ]
  },
  "controls": {
    "applies": {
      "columns": {
        "display": "buttons",
        "kinds": [
          "list"
        ]
      },
      "display": {
        "kinds": [
          "list"
        ]
      },
      "label_position": {
        "kinds": [
          "dropdown",
          "list",
          "input"
        ]
      },
      "layout": {
        "display": "buttons",
        "kinds": [
          "list"
        ]
      },
      "limit": {
        "kinds": [
          "dropdown",
          "list"
        ]
      },
      "max_selections": {
        "kinds": [
          "dropdown",
          "list"
        ],
        "selection": "multi"
      },
      "more_menu": {
        "display": "buttons",
        "kinds": [
          "list"
        ]
      },
      "relevant_only": {
        "kinds": [
          "dropdown",
          "list"
        ]
      },
      "required": {
        "kinds": [
          "dropdown",
          "list",
          "input"
        ]
      },
      "search": {
        "kinds": [
          "dropdown",
          "list"
        ]
      },
      "select_all": {
        "kinds": [
          "dropdown",
          "list"
        ],
        "selection": "multi"
      },
      "show_metric": {
        "kinds": [
          "list"
        ]
      },
      "sort": {
        "kinds": [
          "dropdown",
          "list"
        ]
      }
    },
    "bounds": {
      "columns": [
        2,
        6
      ],
      "default_values": 50,
      "fields_per_page": 5,
      "label_chars": 64,
      "limit": [
        1,
        200
      ],
      "max_selections": [
        2,
        50
      ]
    },
    "button_actions": [
      "link",
      "reset_filters"
    ],
    "defaults": {
      "dropdown": {
        "columns": 3,
        "display": "checkboxes",
        "label_position": "top",
        "layout": "horizontal",
        "limit": 200,
        "max_selections": null,
        "more_menu": false,
        "relevant_only": false,
        "required": false,
        "search": true,
        "select_all": false,
        "show_metric": false,
        "sort": "metric_desc"
      },
      "input": {
        "columns": 3,
        "display": "checkboxes",
        "label_position": "top",
        "layout": "horizontal",
        "limit": 200,
        "max_selections": null,
        "more_menu": false,
        "relevant_only": false,
        "required": false,
        "search": false,
        "select_all": false,
        "show_metric": false,
        "sort": "metric_desc"
      },
      "list": {
        "columns": 3,
        "display": "checkboxes",
        "label_position": "top",
        "layout": "horizontal",
        "limit": 200,
        "max_selections": null,
        "more_menu": false,
        "relevant_only": false,
        "required": false,
        "search": false,
        "select_all": false,
        "show_metric": false,
        "sort": "metric_desc"
      }
    },
    "dimension_kinds": [
      "dropdown",
      "input",
      "list"
    ],
    "displays": [
      "checkboxes",
      "buttons"
    ],
    "kinds": [
      "dropdown",
      "list",
      "input",
      "date_range",
      "button"
    ],
    "label_positions": [
      "top",
      "left"
    ],
    "layouts": [
      "horizontal",
      "vertical",
      "grid"
    ],
    "selections": [
      "single",
      "multi"
    ],
    "sorts": [
      "metric_desc",
      "value_asc",
      "value_desc"
    ]
  },
  "metric_format": {
    "affix_max_chars": 16,
    "decimals": [
      0,
      6
    ],
    "formats": [
      "number",
      "currency",
      "percentage",
      "fraction",
      "count"
    ]
  },
  "pivot": {
    "grains": [
      "daily",
      "weekly",
      "monthly",
      "quarterly",
      "yearly"
    ],
    "period_label_styles": [
      "short",
      "compact",
      "long",
      "iso"
    ]
  },
  "rows": {
    "breakdown": 400,
    "breakdown_series": 8,
    "categorical": 50,
    "table": 500
  },
  "spec_keys": {
    "content": [
      "agent_deep_dive",
      "analysis",
      "bar_column",
      "bar_end_labels",
      "block_type",
      "border",
      "breakdown_key",
      "brief",
      "chart_colors",
      "chart_index_by",
      "chart_type",
      "chart_y_axis",
      "cohort_returns",
      "column_formats",
      "column_picker",
      "comparison_display",
      "conditional_formats",
      "content",
      "control",
      "date_part_keys",
      "date_part_label",
      "default_visible_keys",
      "delta_base_index",
      "dim_labels",
      "dimension_keys",
      "heatmap_keys",
      "highlights",
      "image",
      "instruction",
      "interactions",
      "invert_sentiment",
      "invert_sentiment_keys",
      "labels",
      "legend_position",
      "max_series",
      "metric_directions",
      "metric_format",
      "metric_formats",
      "metric_options",
      "needs_dual_axis",
      "pending_brief",
      "period_label_style",
      "pivot",
      "primary_y_axis",
      "reading",
      "reads",
      "receipt",
      "scope",
      "secondary_line",
      "secondary_y_axis",
      "series_config",
      "shape",
      "surface",
      "table_breakdown_key",
      "table_sort",
      "target_kind",
      "time_dimension_key",
      "time_grain",
      "title",
      "totals",
      "trend_column",
      "viz_type",
      "waterfall",
      "writes_with",
      "x_label",
      "y_keys",
      "y_label"
    ],
    "presentation": [
      "column_picker",
      "default_visible_keys",
      "column_formats",
      "comparison_display",
      "table_breakdown_key",
      "table_sort",
      "conditional_formats",
      "trend_column",
      "bar_column",
      "border",
      "surface",
      "chart_colors"
    ],
    "report_presentation": [
      "column_formats",
      "comparison_display",
      "table_breakdown_key",
      "table_sort",
      "conditional_formats",
      "trend_column",
      "bar_column"
    ],
    "report_refused": [
      "column_picker",
      "default_visible_keys"
    ],
    "report_table_presentation": [
      "column_formats",
      "comparison_display",
      "table_breakdown_key",
      "table_sort",
      "conditional_formats",
      "trend_column",
      "bar_column"
    ],
    "route_owned": [
      "chart_colors",
      "conditional_formats",
      "date_part_label",
      "interactions",
      "period_label_style"
    ],
    "table_presentation": [
      "column_picker",
      "default_visible_keys",
      "column_formats",
      "comparison_display",
      "table_breakdown_key",
      "table_sort",
      "conditional_formats",
      "trend_column",
      "bar_column"
    ]
  },
  "table_sort": {
    "orders": [
      "asc",
      "desc"
    ],
    "parts": [
      "delta"
    ]
  }
} as const;
